import { type OptJobInputData, useOptJobMutation } from 'api/optJobs/optJobs.api'
import { useEffect, useRef, useState } from 'react'
import Datetime from 'utils/datetime/datetime'

const ELECTRICITY_PRICE_SCENARIO_JOB_TYPE = 'electricity_price_scenario'

export function useDayAheadScenarioOptimization(includeSubtypes: string[] | null): {
  createOptimization: () => void
  creatingOptimization: boolean
  optimizationTemporarilyDisabled: boolean
} {
  const { mutate: createOptJob, status } = useOptJobMutation()
  const [optimizationTemporarilyDisabled, setOptimizationTemporarilyDisabled] = useState(false)
  const enableOptimizationTimeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    return () => {
      if (enableOptimizationTimeoutRef.current) {
        clearTimeout(enableOptimizationTimeoutRef.current)
      }
    }
  }, [])

  function createOptimization(): void {
    setOptimizationTemporarilyDisabled(true)
    const inputData: OptJobInputData = {
      opt_start_time: Datetime.getCurrentOptimizationHour(),
      opt_end_time: undefined,
    }

    if (includeSubtypes !== null) {
      inputData.include_subtypes = includeSubtypes
    }

    createOptJob({
      opt_job_type: ELECTRICITY_PRICE_SCENARIO_JOB_TYPE,
      input_data: inputData,
    })

    if (enableOptimizationTimeoutRef.current) {
      clearTimeout(enableOptimizationTimeoutRef.current)
    }
    enableOptimizationTimeoutRef.current = setTimeout(() => {
      setOptimizationTemporarilyDisabled(false)
      enableOptimizationTimeoutRef.current = null
    }, 3500)
  }

  return {
    createOptimization,
    creatingOptimization: status === 'pending',
    optimizationTemporarilyDisabled,
  }
}
